const KEY_SESSION_STORE_TOKEN_ANONYMOUS = 'TOKEN_USR_ANONYMOUS';

export const setTokenUserAnonymous = token => {
  sessionStorage.setItem(KEY_SESSION_STORE_TOKEN_ANONYMOUS, `${token}`);
};

export const getTokenUserAnonymous = () =>
  sessionStorage.getItem(KEY_SESSION_STORE_TOKEN_ANONYMOUS);

export const removeTokenUserAnonymous = () => {
  sessionStorage.removeItem(KEY_SESSION_STORE_TOKEN_ANONYMOUS);
};
